module.exports = __webpack_public_path__ + "img/LTS_SAIT.4df0e59e.gif";